import React from 'react';
import classnames from 'classnames';
import Icon from '../../icon';
import { isDisabledDate, YEAR_TABLE_COL_COUNT, YEAR_TABLE_ROW_COUNT } from '../utils';

class YearTable extends React.PureComponent {
  onYearCellClick(date) {
    this.props.onSelectYear(date, 'month');
  }

  render() {
    const {
      prefix,
      value,
      today,
      visibleMonth,
      disabledDate,
      yearCellRender,
    } = this.props;
    const currentYear = today.year();
    const selectedYear = value ? value.year() : null;
    const visibleYear = visibleMonth.year();
    const startYear = Math.floor(visibleYear / 12) * 12;

    const yearElements = [];
    let counter = 0;

    for (let i = 0; i < YEAR_TABLE_ROW_COUNT; i++) {
      const rowElements = [];
      for (let j = 0; j < YEAR_TABLE_COL_COUNT; j++) {
        let isDisabled = false;
        let onClick;
        const year = startYear + counter++;
        const title = year;
        const yearDate = visibleMonth.clone().year(year);
        isDisabled = isDisabledDate(yearDate, disabledDate, 'year');

        !isDisabled && (onClick = this.onYearCellClick.bind(this, yearDate));

        const content = yearCellRender ? yearCellRender(yearDate) : year;

        const isSelected = year === selectedYear;

        const classNames = classnames({
          [`${prefix}calendar-cell`]: true,
          [`${prefix}calendar-cell-current`]: year === currentYear,
          [`${prefix}selected`]: isSelected,
          [`${prefix}disabled`]: isDisabled,
        });

        rowElements.push(
          <td key={`${i}-${j}`} className={classNames} role="cell">
            <div
              className={`${prefix}calendar-year`}
              onClick={onClick}
              title={title}
              aria-disabled={isDisabled ? 'true' : 'false'}
              aria-selected={isSelected ? 'true' : 'false'}
            >
              {content}
            </div>
          </td>,
        );
      }
      yearElements.push(
        <tr key={i} role="row">
          {rowElements}
        </tr>,
      );
    }
    return (
      <table className={`${prefix}calendar-table`} role="grid">
        <tbody className={`${prefix}calendar-tbody`} role="rowgroup">
          {yearElements}
        </tbody>
      </table>
    );
  }
}

export default YearTable;
